import { type SeriesObservation, shownReference } from '../observation/observation';

/**
 * Canonical revenue resolution (D-09): returns signal.revenue when positive;
 * otherwise infers price × unitsSold (listPrice when price is missing) when units > 0.
 * Returns null when no positive price is available.
 */
export function resolveRevenue(obs: SeriesObservation): number | null {
  const { revenue, unitsSold } = obs.signal;
  if (revenue !== null && revenue > 0) return revenue;
  if (unitsSold === null || unitsSold <= 0) return null;
  const { price } = obs.observed;
  // The observation ACL maps price to the charged price for every vendor (portal-domain.md).
  const charged = [price, shownReference(obs.observed)].find(
    (p): p is number => p !== null && p > 0
  );
  return charged === undefined ? null : charged * unitsSold;
}
